import {trackEvent} from 'analytics/Analytics';
import {HOMEPAGE_ANALYTICS_ACTIONS} from 'constants/analytics-products/HomepageAnalyticsConstants';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import fuzzydate from 'util/fuzzydate';

import {CardSectionRowProps} from '../CardSection';
import {getHomepageFileOutlineIcon} from '../HomepageIconUtil';

interface ReviewableListItem {
  id: string;
  name: string;
  modifiedAt: string;
  editUrl: string;
}

function renderModifiedAt(modifiedAt: string): (isSmall: boolean) => string {
  return (isSmall) =>
    `${isSmall ? '' : 'Updated '}${fuzzydate(modifiedAt, {showTime: false, compact: isSmall})}`;
}

export function reviewableRowProps(item: ReviewableListItem): CardSectionRowProps {
  return {
    id: item.id,
    icon: getHomepageFileOutlineIcon({id: item.id, tagSchema: null, type: null}),
    name: item.name,
    href: item.editUrl,
    onClick: () => {
      trackEvent(HOMEPAGE_ANALYTICS_ACTIONS.CLICKED_MY_WORK_REVIEWABLE);
      SidepanelActions.close({autoOpenFile: false});
    },
    renderRightContent: renderModifiedAt(item.modifiedAt),
  };
}

interface TaskListItem {
  id: string;
  name: string;
  modifiedAt: string;
  url: string;
}

export function taskRowProps({id, name, modifiedAt, url}: TaskListItem): CardSectionRowProps {
  return {
    id,
    icon: getHomepageFileOutlineIcon({id, tagSchema: null, type: null}),
    name,
    href: url,
    onClick: () => {
      trackEvent(HOMEPAGE_ANALYTICS_ACTIONS.CLICKED_MY_WORK_TASK);
      SidepanelActions.close({autoOpenFile: false});
    },
    renderRightContent: renderModifiedAt(modifiedAt),
  };
}
